<template>
  <div :class="{ 'vertical': isVertical }">
    <a
      v-t="'label.home'"
      href="/"
      :class="['header-link', { 'active': isHomePage }]"
      @click.prevent="onClickHome"
    />
    <a
      v-for="(item, index) in renderStore.settings.metaFields.headerLinks"
      :key="index"
      :href="item.url || item.publicUrl"
      :target="item.type === 'external' ? '_blank' : '_self'"
      :class="['header-link', { 'active': isActiveInternalPage(item.slug) }]"
      :rel="rel(item)"
      @click="$emit('click')"
    >
      {{ item.title }}
    </a>
  </div>
</template>

<script setup>
import { ROUTES } from 'src/enums';
import { useRenderStore } from 'stores/render';
import { useRoute, useRouter } from 'vue-router';
import { computed } from 'vue';

defineProps({
  isVertical: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['click']);

const renderStore = useRenderStore();
const router = useRouter();
const route = useRoute();

const isHomePage = computed(() => route.name === ROUTES.RENDER.BLOG);

function isActiveInternalPage(slug) {
  return `/${slug}.html` === route.fullPath;
}

function rel(item) {
  let relText = '';
  if (item.metaFields) {
    if (item.metaFields.nofollow) {
      relText += 'nofollow ';
    }

    if (item.metaFields.noopener) {
      relText += 'noopener ';
    }

    if (item.metaFields.noreferrer) {
      relText += 'noreferrer ';
    }

    return relText.length ? relText.trim() : undefined;
  }

  if (item.nofollow) {
    relText += 'nofollow ';
  }

  if (item.noopener) {
    relText += 'noopener ';
  }

  if (item.noreferrer) {
    relText += 'noreferrer ';
  }

  return relText.length ? relText.trim() : undefined;
}

function onClickHome() {
  router.push({ name: ROUTES.RENDER.BLOG });
  emit('click');
}

</script>
<style lang="scss" scoped>
.header-link {
  padding: 22px 24px;
  overflow: hidden;
  position: relative;
  color: var(--blog-font-color, $grey-4);
  text-decoration: none;
  border-bottom: 1px solid transparent;

  &:hover,
  &.active {
    color: var(--blog-primary-color, $grey-4);
  }

  &.active {
    border-bottom: 1px solid var(--blog-primary-color, $primary);

    &:after {
      content: ' ';
      display: block;
      width: 22px;
      height: 22px;
      border-radius: 22px;
      position: absolute;
      bottom: -11px;
      left: calc(50% - 11px);
      background-color: var(--blog-primary-color, $primary);
      filter: blur(15px);
    }
  }
}
.vertical {
  .header-link.active {
    border-bottom: unset;
    border-right: 1px solid var(--blog-primary-color, $primary);

    &:after {
      display: none;
    }
  }
}
</style>
